export enum ETransmittalItemDocumentType {
  DRAWING = 1,
  DESIGN_REPORT = 2,
  RESPONSE_TO_COMMENT = 3,
  OTHER = 4,
  CERT = 5,
}
